(function() {
    let observer = null;
    let cartUpdateTimeout = null;
    // wo-spinner-fix 2026-09-28: the debounce below used to forget a pending hide whenever any other
    // drawer mutation (countdown tick, Clear Cart link) landed inside its window, leaving the overlay up.
    let pendingHide = false;
    let pendingBundle = false;
    let hideFailsafe = null;
  
    function showCartLoading() {
      const cartDrawer = document.querySelector('cart-drawer');
      if (!cartDrawer) return;
      
      let loadingOverlay = cartDrawer.querySelector('.kv-cart-loading-overlay');
      if (!loadingOverlay) {
        loadingOverlay = document.createElement('div');
        loadingOverlay.className = 'kv-cart-loading-overlay';
        loadingOverlay.innerHTML = `
          <svg class="spinner" viewBox="0 0 50 50">
            <circle cx="25" cy="25" r="20"></circle>
          </svg>
        `;
        cartDrawer.appendChild(loadingOverlay);
      }
      loadingOverlay.classList.add('active');
    }
  
    function hideCartLoading() {
      const cartDrawer = document.querySelector('cart-drawer');
      if (!cartDrawer) return;
      
      const loadingOverlay = cartDrawer.querySelector('.kv-cart-loading-overlay');
      if (loadingOverlay) {
        loadingOverlay.classList.remove('active');
      }
    }

    function setupProductCard(card) {
      if (card.hasAttribute('data-kv-product-card-initialized')) return;
      card.setAttribute('data-kv-product-card-initialized', 'true');
      
      // Setup info icon click handlers
      const infoIcon = card.querySelector('.kv-product-card__info-icon');
      if (infoIcon && !infoIcon.hasAttribute('data-tooltip-initialized')) {
        infoIcon.setAttribute('data-tooltip-initialized', 'true');
        
        infoIcon.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          
          const tooltip = infoIcon.nextElementSibling;
          if (tooltip && tooltip.classList.contains('kv-product-card__tooltip')) {
            // Close all other tooltips first
            document.querySelectorAll('.kv-product-card__tooltip.active').forEach(otherTooltip => {
              if (otherTooltip !== tooltip) {
                otherTooltip.classList.remove('active');
              }
            });
            
            // Toggle current tooltip
            tooltip.classList.toggle('active');
          }
        });
      }

      // Setup variant selection for dropdowns
      const variantSelect = card.querySelector('select[data-variant-select]');
      if (variantSelect && !variantSelect.hasAttribute('data-kv-variant-listener')) {
        variantSelect.setAttribute('data-kv-variant-listener', 'true');
        
        variantSelect.addEventListener('change', event => {
          const select = event.target;
          updateVariantSelection(card, select);
        });
      }

      // Setup variant swatches (radio buttons)
      const swatchContainer = card.querySelector('.kv-product-card__variant-swatches');
      if (swatchContainer && !swatchContainer.hasAttribute('data-kv-swatch-listener')) {
        swatchContainer.setAttribute('data-kv-swatch-listener', 'true');
        
        // Handle clicks on swatch labels
        swatchContainer.addEventListener('click', event => {
          const label = event.target.closest('.kv-product-card__swatch-label');
          if (label && !label.classList.contains('disabled')) {
            const radio = label.querySelector('input[type="radio"]');
            if (radio) {
              radio.checked = true;
              updateVariantSelection(card, radio);
            }
          }
        });

        // Handle direct radio button changes
        swatchContainer.addEventListener('change', event => {
          if (event.target.type === 'radio') {
            updateVariantSelection(card, event.target);
          }
        });
      }
    }

    function updateVariantSelection(card, select) {
      const productForm = card.querySelector('product-form');
      const priceElement = card.querySelector('[data-price]');
      const comparePriceElement = card.querySelector('[data-compare-price]');
      const productImage = card.querySelector('.kv-product-card__image');
      
      let variantId, variantPrice, variantComparePrice;

      if (select.tagName === 'SELECT') {
        const selectedOption = select.options[select.selectedIndex];
        variantId = select.value;
        variantPrice = selectedOption.getAttribute('data-variant-price');
        variantComparePrice = selectedOption.getAttribute('data-variant-compare-price');
        const variantImage = selectedOption.getAttribute('data-variant-image');
        if (variantImage && productImage) {
          productImage.src = variantImage;
        }
      } else if (select.tagName === 'INPUT' && select.type === 'radio') {
        variantId = select.value;
        variantPrice = select.getAttribute('data-variant-price');
        variantComparePrice = select.getAttribute('data-variant-compare-price');
        const variantImage = select.getAttribute('data-variant-image');
        if (variantImage && productImage) {
          productImage.src = variantImage;
        }
      }

      if (productForm) {
        const variantInput = productForm.querySelector('[data-variant-input]');
        if (variantInput) {
          variantInput.value = variantId;
        }
      }
      
      if (priceElement) {
        priceElement.innerHTML = variantPrice || '';
      }
      
      if (comparePriceElement) {
        if (variantComparePrice) {
          comparePriceElement.innerHTML = variantComparePrice;
          comparePriceElement.style.display = 'block';
        } else {
          comparePriceElement.innerHTML = '';
          comparePriceElement.style.display = 'none';
        }
      }
    }
  
    function setupBlock(block) {
      if (block.hasAttribute('data-kv-initialized')) return;
      block.setAttribute('data-kv-initialized', 'true');
      
      // Destroy previous swipers if any
      const existingSwipers = Array.from(block.querySelectorAll('.swiper')).map(el => el.swiper).filter(Boolean);
      existingSwipers.forEach(swiper => swiper.destroy(true, true));
  
      if (block.classList.contains('kv-free-gift-slider')) {
        const freeGiftSwiperEl = block.querySelector('.swiper-free-gift');
        if (freeGiftSwiperEl) {
          new Swiper(freeGiftSwiperEl, {
            slidesPerView: 1.05,
            spaceBetween: 8,
            pagination: {
              el: freeGiftSwiperEl.querySelector('.swiper-pagination'),
              clickable: true,
            },
          });
        }
        return;
      }
      
      // Initialize tabs swiper
      const tabsSwiper = new Swiper(block.querySelector('.tabs-swiper'), {
        slidesPerView: 'auto',
        spaceBetween: 0,
        freeMode: true,
        watchOverflow: true,
        grabCursor: true,
        slideClass: 'swiper-slide',
        slideToClickedSlide: true,
        threshold: 10,
        resistanceRatio: 0.8,
        breakpoints: {
          768: {
            slidesPerView: 'auto',
            spaceBetween: 0,
          }
        }
      });
  
      // Setup info icon click handlers
      block.querySelectorAll('.kv-product-card__info-icon').forEach(infoIcon => {
        if (!infoIcon.hasAttribute('data-tooltip-initialized')) {
          infoIcon.setAttribute('data-tooltip-initialized', 'true');
          
          infoIcon.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            
            const tooltip = infoIcon.nextElementSibling;
            if (tooltip && tooltip.classList.contains('kv-product-card__tooltip')) {
              // Close all other tooltips first
              document.querySelectorAll('.kv-product-card__tooltip.active').forEach(otherTooltip => {
                if (otherTooltip !== tooltip) {
                  otherTooltip.classList.remove('active');
                }
              });
              
              // Toggle current tooltip
              tooltip.classList.toggle('active');
            }
          });
        }
      });
  
      // Remove any existing document click listener
      if (window.tooltipClickHandler) {
        document.removeEventListener('click', window.tooltipClickHandler);
      }
  
      // Create new click handler
      window.tooltipClickHandler = (e) => {
        if (!e.target.closest('.kv-product-card__info-icon') && 
            !e.target.closest('.kv-product-card__tooltip')) {
          document.querySelectorAll('.kv-product-card__tooltip.active').forEach(tooltip => {
            tooltip.classList.remove('active');
          });
        }
      };
  
      // Add the click handler to document
      document.addEventListener('click', window.tooltipClickHandler);
  
      // Add escape key handler
      if (!window.tooltipKeyHandler) {
        window.tooltipKeyHandler = (e) => {
          if (e.key === 'Escape') {
            document.querySelectorAll('.kv-product-card__tooltip.active').forEach(tooltip => {
              tooltip.classList.remove('active');
            });
          }
        };
        document.addEventListener('keydown', window.tooltipKeyHandler);
      }
  
      const swipers = [];
      block.querySelectorAll('.kv-tab-content .swiper').forEach((element, index) => {
        const swiper = new Swiper(element, {
          slidesPerView: 1.15,
          spaceBetween: 12,
          pagination: {
            el: element.querySelector('.swiper-pagination'),
            clickable: true,
          },
          on: {
            slideChange: function() {
              swipers.forEach((otherSwiper, otherIndex) => {
                if (index !== otherIndex && otherSwiper && !otherSwiper.destroyed) {
                  otherSwiper.slideTo(this.activeIndex);
                }
              });
            }
          }
        });
        swipers.push(swiper);
      });
  
      const tabsContainer = block.querySelector('.kv-tabs');
      if (tabsContainer) {
        // Use a flag to prevent adding the same listener multiple times
        if (!tabsContainer.hasAttribute('data-kv-tab-listener')) {
          tabsContainer.setAttribute('data-kv-tab-listener', 'true');
          tabsContainer.addEventListener('click', event => {
            const tab = event.target.closest('.kv-tab');
            if (!tab || tab.classList.contains('active')) return; // Skip if already active
            
            // Get the current active tab content before changing
            const currentContent = block.querySelector('.kv-tab-content.active');
            const newContent = block.querySelector(`.kv-tab-content[data-tab="${tab.dataset.tab}"]`);
            
            if (!newContent || currentContent === newContent) return;
  
            // Update tabs
            block.querySelectorAll('.kv-tab').forEach(t => t.classList.remove('active'));
            tab.classList.add('active');
            
            // Update content
            currentContent.classList.remove('active');
            newContent.classList.add('active');
            
            // Only update the swiper that's becoming visible
            const contentBlocks = Array.from(block.querySelectorAll('.kv-tab-content'));
            const newSwiperIndex = contentBlocks.indexOf(newContent);
            if (swipers[newSwiperIndex] && !swipers[newSwiperIndex].destroyed) {
              swipers[newSwiperIndex].update();
            }
          });
        }
      }
  
      // Use a flag to prevent adding the same listener multiple times
      if (!block.hasAttribute('data-kv-variant-listener')) {
        block.setAttribute('data-kv-variant-listener', 'true');
        block.addEventListener('change', event => {
          const select = event.target.closest('[data-variant-select]');
          if (!select) return;
  
          const card = select.closest('.kv-product-card');
          if (!card) return;
  
          updateVariantSelection(card, select);
        });
      }
    }

    function initKvUpsell() {
      // Initialize cart drawer upsell blocks
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        cartDrawer.querySelectorAll('.kvcart-upsell-block:not([data-kv-initialized])').forEach(setupBlock);
        cartDrawer.querySelectorAll('.kv-product-card:not([data-kv-product-card-initialized])').forEach(setupProductCard);
      }

      // Initialize product page upsell blocks
      document.querySelectorAll('.kv-pdp-upsell-block .kvcart-upsell-block:not([data-kv-initialized])').forEach(setupBlock);
      document.querySelectorAll('.kv-pdp-upsell-block .kv-product-card:not([data-kv-product-card-initialized])').forEach(setupProductCard);

      // Disconnect previous observer if it exists
      if (observer) {
        observer.disconnect();
      }

      // Observe cart drawer for changes if it exists
      if (cartDrawer) {
        observer = new MutationObserver((mutations) => {
          const relevantMutations = mutations.filter(mutation => {
            const targetElement = mutation.target.nodeType === 1 ? mutation.target : mutation.target.parentElement;
            if (!targetElement) return true;
            return !targetElement.closest('#kv-free-gift-removal-status');
          });

          if (relevantMutations.length === 0) return;

          const isCartItemChange = relevantMutations.some(mutation => {
            if (mutation.type !== 'childList') return false;
            const changedNodes = [...mutation.addedNodes, ...mutation.removedNodes];
            return changedNodes.some(node =>
              node.nodeType === 1 && (node.matches('.cart-drawer-item') || node.querySelector('.cart-drawer-item'))
            );
          });

          if (cartUpdateTimeout) {
            clearTimeout(cartUpdateTimeout);
          }

          if (isCartItemChange) {
            showCartLoading();
            pendingHide = true;
            clearTimeout(hideFailsafe);
            hideFailsafe = setTimeout(() => { pendingHide = false; pendingBundle = false; hideCartLoading(); }, 4000);
          }

          const isBundleUpdate = relevantMutations.some(mutation => {
            if (mutation.type !== 'childList') return false;
            const addedItems = [...mutation.addedNodes].filter(node =>
              node.nodeType === 1 && (node.matches('.cart-drawer-item') || node.querySelector('.cart-drawer-item'))
            );
            return addedItems.length > 1;
          });
          if (isBundleUpdate) pendingBundle = true;

          cartUpdateTimeout = setTimeout(() => {
            initKvUpsell();
            initializeTimer();
            if (pendingHide) {
              const bundle = pendingBundle;
              pendingHide = false;
              pendingBundle = false;
              clearTimeout(hideFailsafe);
              if (bundle) {
                setTimeout(hideCartLoading, 500);
              } else {
                hideCartLoading();
              }
            }
          }, pendingBundle ? 1000 : 500); 
        });

        observer.observe(cartDrawer, { childList: true, subtree: true });
      }
    }
  
    function unloadKvUpsell(section) {
      if (observer) {
        observer.disconnect();
        observer = null;
      }
      const block = section.querySelector('.kvcart-upsell-block[data-kv-initialized]');
      if (block) {
        const swipers = Array.from(block.querySelectorAll('.swiper')).map(el => el.swiper).filter(Boolean);
        swipers.forEach(swiper => swiper.destroy(true, true));
        block.removeAttribute('data-kv-initialized');
      }
    }
  
    // Initialize on DOMContentLoaded
    document.addEventListener('DOMContentLoaded', initKvUpsell);

    // Initialize on cart events
    document.addEventListener('cart:updating', showCartLoading);
    document.addEventListener('cart:updated', () => {
      initKvUpsell();
      initializeTimer();
      hideCartLoading();
    });

    // Initialize when cart drawer opens
    document.addEventListener('cart-drawer:open', () => {
      setTimeout(() => {
        initKvUpsell();
        initializeTimer();
      }, 100);
    });

    // Initialize on section load/unload
    document.addEventListener('shopify:section:load', (e) => {
      if (e.target.querySelector('.kvcart-upsell-block') || e.target.querySelector('.kv-pdp-upsell-block')) {
        initKvUpsell();
      }
    });
    document.addEventListener('shopify:section:unload', (e) => {
      unloadKvUpsell(e.target);
    });
    
    if (document.readyState === 'interactive' || document.readyState === 'complete') {
      initKvUpsell();
    }
  
    // Timer functionality
    class KvDrawerTimer {
      constructor() {
        this.timerElement = document.querySelector('.drawer-timer-time');
        if (!this.timerElement) return;
        
        this.hours = 0;
        this.minutes = 15;
        this.seconds = 0;
        
        // Try to get saved time from localStorage
        const savedTime = localStorage.getItem('kvDrawerTimer');
        if (savedTime) {
          const [h, m, s] = savedTime.split(':').map(Number);
          const savedDate = localStorage.getItem('kvDrawerTimerDate');
          
          // If it's a new day, reset the timer
          if (savedDate !== new Date().toDateString()) {
            this.resetTimer();
          } else {
            this.hours = h;
            this.minutes = m;
            this.seconds = s;
          }
        } else {
          this.resetTimer();
        }
        
        this.updateDisplay();
        this.start();
      }
  
      resetTimer() {
        this.hours = 0;
        this.minutes = 15;
        this.seconds = 0;
        localStorage.setItem('kvDrawerTimerDate', new Date().toDateString());
      }
  
      updateDisplay() {
        if (!this.timerElement) return;
        let timeString;
        if (this.hours > 0) {
          timeString = `${String(this.hours).padStart(2, '0')}:${String(this.minutes).padStart(2, '0')}:${String(this.seconds).padStart(2, '0')}`;
        } else {
          timeString = `${String(this.minutes).padStart(2, '0')}:${String(this.seconds).padStart(2, '0')}`;
        }
        this.timerElement.textContent = timeString;
      }
  
      saveTime() {
        localStorage.setItem('kvDrawerTimer', `${this.hours}:${this.minutes}:${this.seconds}`);
        localStorage.setItem('kvDrawerTimerDate', new Date().toDateString());
      }
  
      tick() {
        if (this.seconds > 0) {
          this.seconds--;
        } else if (this.minutes > 0) {
          this.minutes--;
          this.seconds = 59;
        } else if (this.hours > 0) {
          this.hours--;
          this.minutes = 59;
          this.seconds = 59;
        } else {
          this.resetTimer();
        }
        
        this.updateDisplay();
        this.saveTime();
      }
  
      start() {
        // Use a global interval to prevent multiple timers running
        if (window.kvDrawerTimerInterval) {
          clearInterval(window.kvDrawerTimerInterval);
        }
        window.kvDrawerTimerInterval = setInterval(() => this.tick(), 1000);
      }
    }
  
    function initializeTimer() {
      // Ensure only one timer instance is active.
      if (!window.kvDrawerTimer) {
        window.kvDrawerTimer = new KvDrawerTimer();
      } else {
        // If the timer already exists, its DOM element might be stale. Re-acquire it.
        window.kvDrawerTimer.timerElement = document.querySelector('.drawer-timer-time');
        window.kvDrawerTimer.updateDisplay();
      }
    }
  
    // Initialize timer when DOM is loaded
    document.addEventListener('DOMContentLoaded', initializeTimer);
    
    // Also initialize when the cart drawer is opened
    document.addEventListener('cart-drawer:open', initializeTimer);
})();

// Gift removal functionality in a separate scope
(function() {
  function log(msg) {
    const debugRemoval = document.getElementById("kv-free-gift-removal-status");
    if (debugRemoval) debugRemoval.textContent = msg;
    console.log("[Gift Debug]", msg);
  }

  function isThreshold2ReachedLive() {
    const el = document.getElementById("kv-threshold2-status");
    if (!el) return false;
    const raw = el.textContent.trim();
    const match = raw.match(/Threshold2 Reached:\s*(true|false)/i);
    return match ? match[1].toLowerCase() === "true" : false;
  }

  function removeFreeGiftIfThresholdNotMet() {
    const thresholdReached = isThreshold2ReachedLive();
    log("Threshold2 Reached: " + thresholdReached);

    if (!thresholdReached) {
      const freeGiftItems = document.querySelectorAll('.cart-drawer-item[data-is-free-gift="true"]');
      log("Found " + freeGiftItems.length + " free gift drawer item(s).");

      let removed = 0;
      let lastRemoveTime = 0;

      freeGiftItems.forEach((item, index) => {
        if (item.classList.contains("kv-gift-removed")) {
          log(`Gift #${index + 1} already removed earlier.`);
          return;
        }

        const removeBtn = item.querySelector('cart-remove-button .button');
        if (removeBtn) {
          // Add a small delay between multiple removals
          const now = Date.now();
          if (now - lastRemoveTime < 300) {
            return; // Skip if too soon after last removal
          }
          lastRemoveTime = now;
          
          item.classList.add("kv-gift-removed");
          removeBtn.click();
          removed++;
          log(`✅ Removed free gift #${index + 1}`);
          
          // Ensure loading overlay is removed after a delay
          setTimeout(() => {
            const loadingOverlay = document.querySelector('.kv-cart-loading-overlay');
            if (loadingOverlay) {
              loadingOverlay.classList.remove('active');
            }
          }, 500);
        } else {
          log(`⚠️ Remove button not found in gift #${index + 1}`);
        }
      });

      if (removed === 0) {
        log("⚠️ No new gifts removed. Either already gone or no button found.");
        // Also ensure loading overlay is removed if nothing was removed
        const loadingOverlay = document.querySelector('.kv-cart-loading-overlay');
        if (loadingOverlay) {
          loadingOverlay.classList.remove('active');
        }
      }
    } else {
      log("✅ Threshold2 met — no gifts removed.");
    }
  }

  function initGiftRemoval() {
    removeFreeGiftIfThresholdNotMet();
    // Only set interval if it doesn't exist
    if (!window.giftRemovalInterval) {
      window.giftRemovalInterval = setInterval(removeFreeGiftIfThresholdNotMet, 100);
    }
  }

  // Initialize when DOM is loaded
  document.addEventListener('DOMContentLoaded', initGiftRemoval);
  
  // Also initialize when cart drawer is opened
  document.addEventListener('cart-drawer:open', initGiftRemoval);
  
  // Check when cart is updated
  document.addEventListener('cart:updated', initGiftRemoval);
})();